'use client';

import React, { useMemo, useState } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { AgGridReact } from 'ag-grid-react';
import { useEstimator } from '../../context/EstimatorContext';

const SpecialItemsGrid = () => {
  const { formData, setFormData } = useEstimator();

  const [specialItems, setSpecialItems] = useState(
    formData.specialItems?.length > 0
      ? formData.specialItems
      : [
          { account: '141-01-2001', category: 'Line Pipe', item: 'Concrete Coating' },
          { account: '141-01-3003', category: 'Construction Labor', item: 'Deep Water Lay' },
          { account: '141-01-3003', category: 'Construction Labor', item: 'Shallow Water Lay' },
          { account: '141-01-3003', category: 'Construction Labor', item: 'Push/Pull' },
          { account: '141-01-3003', category: 'Construction Labor', item: 'Screw Anchors' },
        ]
  );

  const columnDefs = useMemo(
    () => [
      { headerName: 'Account', field: 'account', cellStyle: { backgroundColor: '#f0f0f0' }, editable: false, flex: 1 },
      {
        headerName: 'Category',
        field: 'category',
        cellStyle: { backgroundColor: '#f0f0f0' },
        editable: false,
        flex: 1,
      },
      { headerName: 'Item', field: 'item', cellStyle: { backgroundColor: '#f0f0f0' }, editable: false, flex: 1 },
      { headerName: 'Quantity', field: 'quantity', editable: true, flex: 1 },
      { headerName: 'Unit (ft, each, etc.)', field: 'unit', editable: true, flex: 1 },
      { headerName: 'Unit Cost', field: 'unitCost', editable: true, flex: 1 },
      {
        headerName: 'Total Cost',
        field: 'totalCost',
        valueGetter: (params) => {
          const qty = parseFloat(params.data.quantity);
          const cost = parseFloat(params.data.unitCost);
          return !isNaN(qty) && !isNaN(cost) ? (qty * cost).toFixed(2) : '-';
        },
        cellStyle: { backgroundColor: '#f0f0f0', color: '#999' },
        flex: 1,
      },
    ],
    []
  );

  const handleGridEdit = (event) => {
    const updated = [...specialItems];
    const index = event.node.rowIndex;
    const updatedRow = { ...event.data };

    const qty = parseFloat(updatedRow.quantity);
    const cost = parseFloat(updatedRow.unitCost);

    updatedRow.totalCost = !isNaN(qty) && !isNaN(cost) ? (qty * cost).toFixed(2) : '-';

    updated[index] = updatedRow;
    setSpecialItems(updated);
    setFormData((prev) => ({ ...prev, specialItems: updated }));
  };

  const handleAddRow = () => {
    const newRow = {
      account: '',
      category: '',
      item: '',
      quantity: '',
      unit: '',
      unitCost: '',
    };
    const updated = [...specialItems, newRow];
    setSpecialItems(updated);
    setFormData((prev) => ({ ...prev, specialItems: updated }));
  };

  return (
    <Box>
      <Typography
        variant="h6"
        mb={2}
        sx={{
          backgroundColor: '#8CA3C4',
          color: 'white',
          padding: '8px 16px',
          borderRadius: 1,
        }}
      >
        Special Items
      </Typography>

      <Box sx={{ maxHeight: 400, overflowY: 'auto', width: '100%' }}>
        <AgGridReact
          rowData={specialItems}
          columnDefs={columnDefs}
          onCellValueChanged={handleGridEdit}
          defaultColDef={{ resizable: true, cellStyle: { textAlign: 'left' } }}
          suppressMovableColumns
          domLayout="autoHeight"
        />
      </Box>

      {/* Add Row Button - Bottom Left */}
      <Box mt={2} display="flex" justifyContent="flex-start">
        <Button variant="contained" onClick={handleAddRow}>
          Add Row
        </Button>
      </Box>
    </Box>
  );
};

export default SpecialItemsGrid;
